import { icon, Icon } from '../lib/fa-icons.js';
/*
Place this widget just before the closing tag of the .Article__Main element
*/
import Widget from "./base.js";
import { setCookie, getCookie } from "tpm-utils";

export class BumperHoliday25MembersWidget extends Widget {
	componentWillMount() {
		//if the paywall postmeta is set, never render this component
		if (window.has_paywall) return;
		this.dismissBumper = this.dismissBumper.bind(this);

		if (getCookie("tpm_bumper_holiday_25_dismissed") === "1") {
			this.state.dismissed = true;
		}

		document
			.querySelector(".js_site-footer")
			.setAttribute("style", "padding-bottom: 100px");
	}

	componentDidMount() {
		window.bh25 = this;
		window.addEventListener("scroll", this.scrollWatcher);
		document
			.querySelector("body")
			.setAttribute("style", "padding-bottom: 80px");
	}

	scrollWatcher() {
		if (window.bh25.state.dismissed) {
			window.removeEventListener("scroll", this.scrollWatcher);
			return;
		}

		let el = document.querySelector(".js_article-content");
		if (window.scrollY > el.getBoundingClientRect().top) {
			bh25.slideUp();
			window.removeEventListener("scroll", this.scrollWatcher);
		}
	}

	slideUp() {
		document
			.querySelector(".BumperHoliday25MembersWidget")
			.classList.add("--slide-up");
	}

	dismissBumper(e) {
		e.preventDefault();
		e.stopPropagation();
		setCookie("tpm_bumper_holiday_25_dismissed", "1", 1);

		this.setState({ dismissed: true });
	}

	get hrefDirect() {
		return `https://talkingpointsmemo.com/memberships`;
	}

	renderContent() {
		if (this.state.dismissed) return;

		return (
			<div className={`BumperHoliday25`}>
				<div
					className={`BumperHoliday25__Inner ${
						this.props.thick ? "--thick" : ""
					}`}
				>
					<div className="BumperHoliday25__Top --shrunk">
						<div className="BumperHoliday25__TopRight">
							<img
								src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/holiday25/tpm-gift-single.png`}
								aria-hidden="true"
								className="BumperHoliday25__GiftBox --shrunk"
							/>
							<div className="BumperHoliday25__Body --shrunk">
								<p className="big">This Holiday Season Give The Gift Of TPM</p>
							</div>
							<div className="BumperHoliday25__Buttons">
								<a href={this.hrefDirect} className="Button --navy">
									25% Off Gift Memberships
								</a>
							</div>
							<div
								className="BumperHoliday25__Shrink --shrunk"
								onClick={this.dismissBumper}
							>
								<Icon name="xmark" style="light" />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
